import { HeadingTag, UtilTitleSimpleTextImage } from '@sapientpro/sapientpro-data-models';
import classNames from 'classnames';
import { useAtomValue } from 'jotai';
import styles from './CaseSlider.module.scss';
import Img from '../../../../components/Img';
import DynamicHeading from '../../../../components/DynamicHeading';
import { Theme, theme } from '../../../../store/theme';

export type SliderItem = {
  id: number;
  content: UtilTitleSimpleTextImage[];
};

const CaseSliderItem = ({ data, doubled, headingTag }: { data: SliderItem; doubled?: boolean; headingTag: HeadingTag; }) => {
  const appTheme = useAtomValue(theme);

  return (
    <div className={classNames(styles.sliderItem, {
      [styles.doubledView]: doubled,
    })}
    >
      {
    data.content.map((item) => {
      const darkImage = item.darkImage || item.image;
      const image = appTheme === Theme.DARK ? darkImage : item.image;

      return (
        <div
          key={item.id}
          className={styles.itemContent}
        >
          <div className={styles.sliderItemHead}>
            <DynamicHeading
              headingTag={headingTag}
              className={styles.itemTitle}
              nestingLevel={1}
            >
              {item.title}
            </DynamicHeading>
            <p className={classNames(styles.itemText, 'bodyLarge')}>{item.description}</p>
          </div>
          <Img
            src={image.url}
            width={image.width}
            height={image.height}
            alt={image.alternativeText || 'content image'}
            className={styles.itemImage}
          />
        </div>
      );
    })
  }
    </div>
  );
};

export default CaseSliderItem;
